module.exports = __webpack_public_path__ + "img/Product-details-UI.aa32cb95.jpg";